import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import { register as registerServiceWorker } from './serviceWorkerRegistration';

const queryClient = new QueryClient();

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
// Keep the portal available offline; tell the UI when an update is waiting.
registerServiceWorker({
  onUpdate: (registration) => window.dispatchEvent(new CustomEvent('wmf-sw-update', { detail: registration })),
});
